<template>
<Dialog header="Koşul Paketi" 
v-model:visible="show" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '75vw'}"
:modal="true"
>

<div class="grid">
	<div class="col-12"><h4 class="text-pink-500 my-0 ">Koşullar</h4></div>

	<!--conditions-->
	<div class="col-12" v-for="condition in bundle.conditions">
	<Dropdown 
	:filter="true"  
	v-model="condition.selected_input" 
	:options="theinputs" 
	optionLabel="title"   
	class=" p-inputtext-sm mt-2 w-4" 
	@change="inputSelected(condition.id)"/>

	<template  v-if="condition.selected_input && condition.selected_input.id!=='unconditionally'">
	<span class="ml-2">için değer</span>
	<Dropdown 
	:filter="false"  
	v-model="condition.comparison_type" 
	:options="comparison_types" 
	optionLabel="name" 
	optionValue="code" 
	class="ml-2 p-inputtext-sm mt-2" 
	@change="comparisonTypeSelected(condition.id)"
	/>




	<template v-if="condition.comparison_type">
		<!-- input type comparison -->
		<template v-if="condition.comparison_type=='input'">
			<Dropdown 
			:filter="false"  
			v-model="condition.comparison_input" 
			:options="inputs" 
			optionLabel="title" 
			class="ml-2 p-inputtext-sm mt-2" 
			/>
			<Dropdown 
			:filter="false"  
			v-model="condition.execution_type" 
			:options="numberoperators" 
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			/>

			<template v-if="condition.comparison_input && condition.execution_type">
				<Dropdown 
				:filter="false"  
				v-model="condition.operator" 
				:options="conditionoperators" 
				optionLabel="name" 
				optionValue="code" 
				class="ml-2 p-inputtext-sm mt-2" 
				@change="conditionOperatorSelected(condition.id)"
				/>
			</template>
		</template>
		<!-- input type comparison -->
		<!-- input value comparison -->
		<template v-if="condition.comparison_type=='value'">
			<InputNumber  
			placeholder="Sayısal değeri" 
			v-model="condition.numerical_val" 
			class="ml-2 p-inputtext-sm mt-2"/>
			<Dropdown 
			:filter="false"  
			v-model="condition.execution_type" 
			:options="numberoperators" 
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			/>

			<template v-if="condition.numerical_val && condition.execution_type">
				<Dropdown 
				:filter="false"  
				v-model="condition.operator" 
				:options="conditionoperators" 
				optionLabel="name" 
				optionValue="code" 
				class="ml-2 p-inputtext-sm mt-2" 
				@change="conditionOperatorSelected(condition.id)"
				/>
			</template>
		</template>
		<!-- input value comparison -->
		
	</template>

	</template>
	<Button icon="pi pi-trash"  class="p-button-outlined p-button-sm p-button-danger ml-2 mt-2"   @click="removeCondition(condition.id)"></Button>
	</div>
	<!--conditions-->


	<!--outcome-->
	<template v-if="bundle.outcome">
	<div class="col-12"><h4 class="text-pink-500 my-0 ">Çıktı</h4></div>
	<div class="col-12">
	<Dropdown 
	:filter="false"  
	v-model="bundle.outcome.comparison_type" 
	:options="comparison_types" 
	optionLabel="name" 
	optionValue="code" 
	class="ml-2 p-inputtext-sm mt-2" 
	/>
	<!-- input type -->
	<Dropdown 
		v-if="bundle.outcome.comparison_type=='input'"
		:filter="false"  
		v-model="bundle.outcome.comparison_input" 
		:options="inputs" 
		optionLabel="title" 
		class="ml-2 p-inputtext-sm mt-2 w-4" 
	/>
	<!-- input type -->

	<!-- value type -->
	<InputNumber  
			placeholder="Sayısal değeri" 
			v-if="bundle.outcome.comparison_type=='value'"
			v-model="bundle.outcome.numerical_val" 
			class="ml-2 p-inputtext-sm mt-2"/>
	<!-- value type -->

	<span class="ml-2" v-if="bundle.outcome.numerical_val || bundle.outcome.comparison_input">
		olarak belirle.
	</span>


	</div>




	</template>
	<!--outcome-->



</div>

<template #footer>
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check" @click="hideModal"  class=" p-button-primary p-button-outlined  p-button-sm"  />
</template>

</Dialog>
</template>

<script>
const conditionmodel = {
		  id:null,
	    type:null,//inputfield,customattribute
	    comparison_type:null,
	    selected_input:null,
	    comparison_input:null,
	    text_val:null,
	    numerical_val:null,
	    execution_type:null,
	    operator:null,
		}
const outcomemodel = {
			id:null,
			text_val:null,
			numerical_val:null,
			operator:null,
			comparison_type:null,
		}

export default {

  name: 'LogicBundle',
  props:["inputs","node"],
  data () {
    return {
    	show:false,
    	bundle:null,
    	theinputs:[],    	
    	comparison_types:[
	    	{name:"Veri",code:"input"},
	    	{name:"Tam Değer",code:"value"},
    	],
    	numberoperators:[
	    	{name:"değerine eşitse",code:"equal_to"},
	    	{name:"değerine eşit değilse",code:"not_equal_to"},
	    	{name:"değerinden büyükse",code:"greater_than"},
	    	{name:"değerinden küçükse",code:"less_than"},
	    	{name:"değer mevcutsa",code:"input_filled"},
    	],
    	conditionoperators:[
	    	{name:"ve",code:"and"},
	    	{name:"ya da",code:"or"},
	    	{name:"tamamla",code:"execute"},
    	],
    }
  },
  computed:{

  },
  watch:{
  	show()
  	{
  		if(!this.show)
  		{
  			this.$emit("conditionUpdated",this.bundle)
  			setTimeout(()=>{
  				this.theinputs = []
	  			this.bundle = null
  			})	  		
  		}
  	}
  },
  methods:{
  	conditionOperatorSelected(condition_id)
  	{
  		let condition = this.bundle.conditions.find(item=>item.id == condition_id)
  		if(condition.operator=="execute")
  		{
  			this.addOutcome()
  		}
  		else
  		{
  			this.addCondition()
  		}
  	},
  	removeCondition(condition_id)
  	{
  		this.bundle.conditions = this.bundle.conditions.filter(item=>item.id !== condition_id)
  		if(!this.bundle.conditions.length)
  		{
  			this.bundle.outcome = null
  			this.addCondition()
  		}
  	},
  	comparisonTypeSelected(condition_id)
  	{

  	},
  	inputSelected(condition_id)
  	{
  		let ind = this.bundle.conditions.findIndex(item=>item.id == condition_id)
  		if(this.bundle.conditions[ind].selected_input.id=="unconditionally")
  		{
  			this.bundle.conditions[ind].operator = "execute"
  			this.addOutcome()
  		}
  	},
  	addOutcome()
  	{
  		if(!this.bundle.outcome)
  		{
  			let outcome = this.sanitizeArray(outcomemodel)
  			this.bundle.outcome = outcome
  		}
  		
  	},
  	addCondition()
  	{
  		let condition = this.sanitizeArray(conditionmodel)
  		condition.id = this.generateId()
      this.bundle.conditions.push(condition)
  	},
  	showModal(bundle)
  	{
  		console.log("showModal");
  		console.log(this.inputs);
  		this.bundle = bundle
  		this.theinputs.push({title:"Koşulsuz olarak",id:"unconditionally"})
  		this.theinputs = this.theinputs.concat(this.inputs)
  		console.log(this.inputs);
  		this.show = true
  	},
  	hideModal()
  	{
  		this.show = false
  	},
  }
}
</script>

<style lang="css" scoped>
</style>